import React from 'react'
import { SiteContainer, Main, Flex, FlexItem, Wrapper } from 'core/layout'
import { Heading, Card, Hairline, Anchor } from 'elements'
import { RawContent } from 'elements/util'
import { Link } from 'react-router-dom'
import getHomeURL from 'utils/getHomeURL';
import tulkojumi from 'utils/tulkojumi';
import { SitemapList } from './styled';

class Sitemap extends React.PureComponent {

  _renderLevel(sitemap, level, parent_id) {
    if (sitemap && sitemap[level]) {
      const homeURL = getHomeURL(this.props.lang);
      const filtered = sitemap[level].filter(page => page.parent == parent_id)
        .filter(page => page.path !== homeURL);
      return filtered.length > 0 ? (
        <SitemapList>
          { filtered.map((page, index) => {
              return (
                <li key={ index }>

                  <Link to={ page.rewrite_source?page.rewrite_source:page.rewrite_url?page.rewrite_url:page.path }>
                    { page.title }
                  </Link>

                  { this._renderLevel(sitemap, page.level + 1, page._id) }
                </li>
              )
            }) }
        </SitemapList>
      ) : null;
    } else {
      return null;
    }
  }


  render() {
    const props = this.props
    let level = 0
    let sitemap = []
    sitemap[level] = []
    props.sitemap && props.sitemap.map((page, index) => {
      if (level !== page.level) {
        level = page.level
        sitemap[level] = []
      }
      sitemap[level].push(page)
    })


    return (
      <SiteContainer>
        <Wrapper>
          <Flex>
            <Main>
              <Heading>
                { props.init_page.title }
              </Heading>
              {this._renderLevel(sitemap, 0, 0)}
            </Main>
          </Flex>
        </Wrapper>
      </SiteContainer>
    )
  }
}

export default Sitemap



// WEBPACK FOOTER //
// ./src/pages/Sitemap/Sitemap.jsx